import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconProfilePicture = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.617 11.5552C12.4306 11.5552 13.9009 10.0849 13.9009 8.27125C13.9009 6.45758 12.4306 4.9873 10.617 4.9873C8.80326 4.9873 7.33301 6.45758 7.33301 8.27125C7.33301 10.0849 8.80326 11.5552 10.617 11.5552Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7778 1H5.22222C2.89035 1 1 2.89035 1 5.22222V15.7778C1 18.1096 2.89035 20 5.22222 20H15.7778C18.1096 20 20 18.1096 20 15.7778V5.22222C20 2.89035 18.1096 1 15.7778 1Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.52283 19.5311C4.48903 18.7121 4.6186 17.8947 4.90369 17.1278C5.18879 16.361 5.62352 15.6607 6.1818 15.0691C6.74007 14.4774 7.41035 14.0067 8.15227 13.685C8.89416 13.3634 9.69247 13.1978 10.4991 13.1978C11.3057 13.1978 12.104 13.3634 12.8459 13.685C13.5878 14.0067 14.2581 14.4774 14.8164 15.0691C15.3746 15.6607 15.8093 16.361 16.0944 17.1278C16.3795 17.8947 16.509 18.7121 16.4753 19.5311",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconProfilePicture;
